module.exports = {"mainbox1Header":"Title","mainbox1Text":"Text here","mainbox2Header":"Title","mainbox2Text":"Text here","mainbox3Header":"Title","mainbox3Text":"Text here","firstServiceHeader":"Service","firstServiceText":"Text here","secondServiceHeader":"Service","secondServiceText":"Text here","readmore":"Read more"}


//////////////////
// WEBPACK FOOTER
// ./src/app/service/lang/en.lang.json
// module id = 348
// module chunks = 1